module.exports = __webpack_public_path__ + "static/media/logo-100-open-angels.26dbd67e.png";